import { css } from 'styled-components';
import token from 'styled-token';

/** @class PropertyCardBodyMixin */
/** @method */
export var PropertyCardBodyMixin = function PropertyCardBodyMixin() {
  return token({
    // Same as Card
    borderRadius: 'PropertyCard.cardBody.borderRadius'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius;
    return css(["border-radius:", "px;"], borderRadius);
  });
};